import React from "react";
import "Validation/yup/methods";
import "Styles/Pages/signing-page.scss";
import * as Icons from "Components/Icons";
import { SigningForm, SigningFormProps } from "./Components/Signing/SigningForm";
import { render } from "react-dom";
import { parseJsonFromDataAttributeEncoded } from "Utils/parseJsonFromDataAttributeEncoded";
import { Provider } from "react-redux";
import uikitcolors from "Styles/UIKit/uikit-colors.module.scss";
import { CookiesProvider } from "react-cookie"

export type SigningPageProps = Omit<SigningFormProps, "isModal" | "closeModal">;

export const SigningPage: React.FC<SigningPageProps> = ({ ...signingFormProps }) => {
   return (
      <Provider store={LSStore.instance}>
         <CookiesProvider>
            <div className="signing-page">
               <div className="signing-page-left">
                  <div className="signing-page-header">
                     <a href="/"><Icons.LiquidSpaceLogoFull className="signing-page-header-logo" color={uikitcolors["deep-sea"]} preserveAspectRatio="xMinYMid slice" /></a>
                  </div>
                  <SigningForm className="signing-page-form" {...signingFormProps} />
                  <div className="signing-page-footer">
                     © LiquidSpace, Inc. {new Date().getFullYear()}
                  </div>
               </div>
               <div className="signing-page-right">
                  <div className="signing-page-moto">
                     <div className="signing-page-moto-line"></div>
                     <div className="signing-page-moto-row">
                        Work from where it works
                     </div>
                     <div className="signing-page-moto-row">
                        <span className="signing-page-moto-highlight">
                           for you.
                        </span>
                     </div>
                  </div>
               </div>
            </div>
         </CookiesProvider>
      </Provider>
   )
}

const pageRoot = document.getElementById("signing-page")!;
const registerModel = parseJsonFromDataAttributeEncoded<LSWebUI.Models.RegisterModel>(pageRoot, "registerModelEncoded");
const changePasswordModel = parseJsonFromDataAttributeEncoded<LSWebUI.Models.ForgotPasswordViewModel>(pageRoot, "changePasswordModelEncoded");
const initialMode = pageRoot.dataset["initialMode"]! as string;
const initialEmail = pageRoot.dataset["initialEmail"]! as string;
const initialFullName = pageRoot.dataset["initialFullName"]! as string;
const returnUrl = pageRoot.dataset["returnUrl"]! as string;
const loginMessage = pageRoot.dataset["loginMessage"]! as string;
const registerMessage = pageRoot.dataset["registerMessage"]! as string;

const signingPageProps: SigningPageProps = {
   mode: LSStore.SigningMode[initialMode],
   returnUrl: returnUrl,
   initialEmail: initialEmail ? initialEmail : undefined,
   registerModel: registerModel,
   registerFormProps: undefined,
   loginFormProps: undefined,
   changePasswordFormProps: changePasswordModel
}

if (loginMessage) {
   signingPageProps.loginFormProps = {
      message: loginMessage
   };
}


if (registerMessage || initialFullName) {
   signingPageProps.registerFormProps = {
      Message: registerMessage,
      FullName: initialFullName,
   };
}

render(<SigningPage {...signingPageProps} />, pageRoot);